import React from 'react';
import styled from 'styled-components';

import SpinningRoundedBorder from 'components/basic/animations/SpinningRoundedBorder';

const FullScreen = styled.div`
  z-index: 999888777;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  text-align: center;
  background: #00000077;
  padding-top: calc(50vh - 50px);
`;

function SigningOutSpinnerOverlay() {
  return (
    <FullScreen>
      <SpinningRoundedBorder inline size={100} />
      {/* <p style={{ textAlign: 'center' }}>Please wait...</p> */}
    </FullScreen>
  );
}

export default SigningOutSpinnerOverlay;
